import { Box, LinearProgress } from "@mui/material";

interface ProgressProps {
    image: any;
    height: string;
    ItemProgressContainer: string;
    ItemProgressBar: string;
}

const COLORS = {
    BACKGROUND: {
        LOW: '#FFEDD5',
        HIGH: '#DCFCE7',
    },
    BAR: {
        LOW: '#EF4444',
        MEDIUM: '#F97316',
        HIGH: '#22C55E',
    },
} as const;

const getQualityScore = (image: any): number => {
    const baseScore = image.image_quality_score ?? 0;

    const hasLowLightDone = image.doneEnhancments?.includes("Low Light Enhancement");
    const hasSuperResolutionDone = image.doneEnhancments?.includes("Image Super Resolution");

    let scorePlus = 0;
    if (hasLowLightDone) scorePlus += 15;
    if (hasSuperResolutionDone) scorePlus += 20;
    const score = baseScore + scorePlus;
    return score <= 100 ? score : 100;
};

const isCriticalRecommendation = (image: any, enhancementName: string): boolean => {
    return image.recommendation.some(
        (rec: any) => rec.apiname === enhancementName && rec.state === "Critical"
    );
};

const getBarColor = (image: any): string => {
    const hasLowLightCritical = isCriticalRecommendation(image, "Low Light Enhancement");
    const hasSuperResolutionCritical = isCriticalRecommendation(image, "Image Super Resolution");

    const hasLowLightDone = image.doneEnhancments?.includes("Low Light Enhancement");
    const hasSuperResolutionDone = image.doneEnhancments?.includes("Image Super Resolution");

    // Return LOW color if any critical enhancement is not done
    if (hasLowLightCritical && !hasLowLightDone) {
        return COLORS.BAR.LOW;
    }

    if (hasSuperResolutionCritical && !hasSuperResolutionDone) {
        return COLORS.BAR.LOW;
    }
    // Return HIGH color if:
    // 1. No enhancements are critical, OR
    // 2. All critical enhancements are done
    return COLORS.BAR.HIGH;
};

const getProgressStyles = (image: any, height: string) => ({
    backgroundColor: getBarColor(image) === "#EF4444" ? " #FFEDD5" : "#DCFCE7",
    height: height,
    borderRadius: '70px',
    '& .MuiLinearProgress-bar': {
        backgroundColor: getBarColor(image),
    },
});


export function ProgressBar({ image, height, ItemProgressContainer, ItemProgressBar }: ProgressProps) {

    const qualityScore = getQualityScore(image);
    const progressStyles = getProgressStyles(image, height);

    return (
        <div className={ItemProgressContainer} >
            <div className={ItemProgressBar}>
                <Box sx={{ width: '100%' }}>
                    <LinearProgress
                        variant="determinate"
                        sx={progressStyles}
                        value={qualityScore}
                    />
                </Box>
            </div>
        </div>
    )
}